import $ from 'jquery';

// Scripts to handle basket methods ...

$(function() {

    initAddBasketItem();

    initDeleteBasketItem();

    initUpdateBasketItem();

});


function initAddBasketItem() {

    //console.log('initAddBasketItem');

    $('.add-to-basket').unbind('click');
    $('.add-to-basket').on('click', function(e) {

        //console.log('add-item click');

        let productVariantId = $(this).attr('data-product-variant-id');
        let itemQuantity = $(this).attr('data-item-quantity');

        return axios.post('/manager/ecommerce/basket/add-item', {
            productVariantId: productVariantId,
            itemQuantity: itemQuantity
        }).then(function (response) {
            //console.log(response);
            updateHeaderBasketItemCount(response);
        })
        .catch(function (error) {
            console.log(error);
        });

    });

}


function initDeleteBasketItem() {

    //console.log('initDeleteBasketItem');

    $('.basket-item-delete').unbind('click');
    $('.basket-item-delete').on('click', function(e) {

        //console.log('basket-item-delete click');

        let basketItemId = $(this).attr('data-basket-item-id');

        return axios.post('/manager/ecommerce/basket/delete-item', {
            basketItemId: basketItemId
        }).then(function (response) {
            updateBasket(basketItemId, response);
        })
            .catch(function (error) {
                console.log(error);
            });

    });

}


function initUpdateBasketItem() {

    //console.log('initUpdateBasketItem');

    $('.basket-item-quantity').unbind('change');
    $('.basket-item-quantity').on('change', function(e) {

        //console.log('basket-item-update blur');

        updateBasketItem($(this));

    });

}

window.updateBasketItem = function (el) {
    //console.log('updateBasketItem');

    let basketItemId = el.attr('data-basket-item-id');
    let quantity = el.val();

    let itemWrapper = $(".basket-item-wrapper[data-item-id='" + basketItemId + "']");

    itemWrapper.each(function() {
        $(this).find('.basket-item-quantity').val(quantity);
        $(this).find('.basket-loader').removeClass('hidden');
    });

    $('.modify-quantity').each(function() {
        $(this).prop('disabled', true);
    });

    $('.basket__totals .basket-loader').removeClass('hidden');

    return axios.post('/manager/ecommerce/basket/update-item', {
        basketItemId: basketItemId,
        quantity: quantity
    }).then(function (response) {
        //console.log(response);
        updateBasket(basketItemId, response);

        $('.modify-quantity').each(function() {
            $(this).prop('disabled', false);
        });
    }).catch(function (error) {
        console.log(error);
    });
}


function updateBasket(basketItemId, basketDetails) {

    //console.log('updateBasket');
    //console.log(basketDetails);

    updateHeaderBasketItemCount(basketDetails);

    if (basketDetails.data.items.length === 0) {
        // reload the page
        location.reload();
        // Can't remember whether I commented this out for debugging or to fix something ...
        //console.log('location.reload() commented out');
        return false;
    }

    let basketItemIds = [];

    // Get an array of row ids
    $('tr.basket-item-wrapper[data-item-id]').each(function() {
        // Note the + to force the id to an integer rather than a string,
        // otherwise the removal sequence doesn't find a match
        basketItemIds.push(+$(this).attr('data-item-id'));
    });

    //console.log(basketItemId);
    //console.log(basketDetails.data.items);

    basketDetails.data.items.forEach(function(item) {

        let idx = basketItemIds.indexOf(item.item_id);
        if (idx > -1) {
            basketItemIds.splice(idx, 1);
        }
    });

    let currencySymbol = basketDetails.data.currency_symbol;

    updateBasketItemTotal(basketItemId, currencySymbol, basketDetails.data.items);
    updateBasketTotals(currencySymbol, basketDetails)

    // if ((basketDetails.data.has_insufficient_stock_items) || (basketDetails.data.has_out_of_stock_items)) {
    //     $('form.custom-order-details').addClass('hidden');
    // } else {
    //     $('form.custom-order-details').removeClass('hidden');
    // }

    $('.basket-item-wrapper .basket-loader').addClass('hidden');

    if (basketItemIds.length) {
        basketItemIds.forEach(function(itemId) {
            $('.basket-item-wrapper[data-item-id=' + itemId + ']').remove();
        });
    }

    console.log(typeof customUpdateBasket);

    // Run a client specific routine to update the basket display if it exists
    if (typeof customUpdateBasket === 'function') {
        //console.log('customUpdateBasket defined');
        customUpdateBasket(basketDetails.data);
    } else {
        //console.log('customUpdateBasket not defined');
    }

}

function updateBasketItemTotal(basketItemId, currencySymbol, items) {

    //console.log('updateBasketItemTotal');

    let item = '';

    items.forEach(function(row) {
        //console.log(row.item_id);
        if(row.item_id === +basketItemId) {
            item = row;
        }
    });

    let id = item.item_id;

    let itemWrappers = $(".basket-item-wrapper[data-item-id='" + id + "']");

    $(itemWrappers).each(function() {
        $(this).find('.basket-item-total').text(currencySymbol + item.item_gross);
    });

    // let basketItemId = item.item_id;
    //
    // let idx = basketItemIds.indexOf(basketItemId);
    // if (idx > -1) {
    //     basketItemIds.splice(idx, 1);
    // }
    //
    // let $tr = $('tr[data-basket-item-id=' + basketItemId + ']');
    //
    // $tr.find('input.basket-item-quantity').val(item.quantity);
    // $tr.find('td.basket-item-gross').text(currencySymbol + item.item_gross);

    //console.log(basketItemId);
}

function updateBasketTotals(currencySymbol, basketDetails) {

    //console.log('updateBasketTotals');

    $('#basket-item-total').text(currencySymbol + basketDetails.data.item_total);

    $('#basket-discount').text(currencySymbol + basketDetails.data.discount);

    if (basketDetails.data.discount_num > 0) {
        $('#basket-discount').closest('.basket__totals__row').removeClass('hidden');
    } else {
        $('#basket-discount').closest('.basket__totals__row').addClass('hidden');
    }

    $('#basket-shipping').text(currencySymbol + basketDetails.data.shipping_gross);

    if (basketDetails.data.shipping_gross_num > 0) {
        $('#basket-shipping').closest('.basket__totals__row').removeClass('hidden');
    } else {
        $('#basket-shipping').closest('.basket__totals__row').addClass('hidden');
    }

    $('#basket-net-tax').text(currencySymbol + basketDetails.data.net_tax);

    $('#basket-net-total').text(currencySymbol + basketDetails.data.net_total);

    $('.basket__totals .basket-loader').addClass('hidden');
}


function updateHeaderBasketItemCount(basketDetails) {

    //console.log('updateHeaderBasketItemCount');

    // Find the basket count li in the header and update with the new number, or remove altogether if 0
    let basketItemCount = basketDetails.data.basket_item_count;

    let $basketItemCountElement = $('#basket-count');

    if (basketItemCount) {
        $basketItemCountElement.html(basketItemCount);
    } else {
        $basketItemCountElement.html('');
    }

}
